type FunnelEvent =
  | 'click_subscribe'
  | 'stripe_success'
  | 'click_install_snap'
  | 'snap_installed'
  | 'wallet_connected'
  | 'subscription_verified';

export function trackEvent(event: FunnelEvent, data?: Record<string, unknown>) {
  console.log('[CryptoGuardians]', event, data ?? '');
}
